<template>
  <div>
    <div class="input-row-2">
      <div>
        <div class="inputCard">
          <header>Sections</header>
          <div class="content">
            <div class="cardRow w3-padding-8">
              <label class="w3-label">Services</label>
              <div class="w3-right-align">
                <label class="switch">
                  <input type="checkbox" v-model="state.siteData.content.services.enabled">
                  <span class="slider"></span>
                </label>
              </div>
            </div>
            <div class="cardRow w3-padding-8">
              <label class="w3-label">Products</label>
              <div class="w3-right-align">
                <label class="switch">
                  <input type="checkbox" v-model="state.siteData.content.products.enabled">
                  <span class="slider"></span>
                </label>
              </div>
            </div>
            <div class="cardRow w3-padding-8">
              <label class="w3-label">News</label>
              <div class="w3-right-align">
                <label class="switch">
                  <input type="checkbox" v-model="state.siteData.content.news.enabled">
                  <span class="slider"></span>
                </label>
              </div>
            </div>
            <div class="cardRow w3-padding-8">
              <label class="w3-label">Properties</label>
              <div class="w3-right-align">
                <label class="switch">
                  <input type="checkbox" v-model="state.siteData.content.properties.enabled">
                  <span class="slider"></span>
                </label>
              </div>
            </div>
            <div class="cardRow w3-padding-8">
              <label class="w3-label">Units</label>
              <div class="w3-right-align">
                <label class="switch">
                  <input type="checkbox" v-model="state.siteData.content.units.enabled">
                  <span class="slider"></span>
                </label>
              </div>
            </div>
            <div class="cardRow w3-padding-8">
              <label class="w3-label">Land</label>
              <div class="w3-right-align">
                <label class="switch">
                  <input type="checkbox" v-model="state.siteData.content.land.enabled">
                  <span class="slider"></span>
                </label>
              </div>
            </div>
            <div class="cardRow w3-padding-8">
              <label class="w3-label">Events</label>
              <div class="w3-right-align">
                <label class="switch">
                  <input type="checkbox" v-model="state.siteData.content.events.enabled">
                  <span class="slider"></span>
                </label>
              </div>
            </div>
            <div class="cardRow w3-padding-8">
              <label class="w3-label">Portfolio</label>
              <div class="w3-right-align">
                <label class="switch">
                  <input type="checkbox" v-model="state.siteData.content.portfolio.enabled">
                  <span class="slider"></span>
                </label>
              </div>
            </div>
            <div class="cardRow w3-padding-8">
              <label class="w3-label">Photos</label>
              <div class="w3-right-align">
                <label class="switch">
                  <input type="checkbox" v-model="state.siteData.content.photos.enabled">
                  <span class="slider"></span>
                </label>
              </div>
            </div>
            <div class="cardRow w3-padding-8">
              <label class="w3-label">Documents</label>
              <div class="w3-right-align">
                <label class="switch">
                  <input type="checkbox" v-model="state.siteData.content.documents.enabled">
                  <span class="slider"></span>
                </label>
              </div>
            </div>
            <div class="cardRow w3-padding-8">
              <label class="w3-label">Videos</label>
              <div class="w3-right-align">
                <label class="switch">
                  <input type="checkbox" v-model="state.siteData.content.videos.enabled">
                  <span class="slider"></span>
                </label>
              </div>
            </div>
            <div class="cardRow w3-padding-8">
              <label class="w3-label">Audio</label>
              <div class="w3-right-align">
                <label class="switch">
                  <input type="checkbox" v-model="state.siteData.content.audio.enabled">
                  <span class="slider"></span>
                </label>
              </div>
            </div>
            <div class="cardRow w3-padding-8">
              <label class="w3-label">Testimonials</label>
              <div class="w3-right-align">
                <label class="switch">
                  <input type="checkbox" v-model="state.siteData.content.testimonials.enabled">
                  <span class="slider"></span>
                </label>
              </div>
            </div>
            <div class="cardRow w3-padding-8">
              <label class="w3-label">Partners</label>
              <div class="w3-right-align">
                <label class="switch">
                  <input type="checkbox" v-model="state.siteData.content.partners.enabled">
                  <span class="slider"></span>
                </label>
              </div>
            </div>
            <div class="cardRow w3-padding-8">
              <label class="w3-label">Team</label>
              <div class="w3-right-align">
                <label class="switch">
                  <input type="checkbox" v-model="state.siteData.content.team.enabled">
                  <span class="slider"></span>
                </label>
              </div>
            </div>
            <div class="cardRow w3-padding-8">
              <label class="w3-label">Faqs</label>
              <div class="w3-right-align">
                <label class="switch">
                  <input type="checkbox" v-model="state.siteData.content.faqs.enabled">
                  <span class="slider"></span>
                </label>
              </div>
            </div>
            <div class="cardRow w3-padding-8">
              <label class="w3-label">Users</label>
              <div class="w3-right-align">
                <label class="switch">
                  <input type="checkbox" v-model="state.siteData.content.users.enabled">
                  <span class="slider"></span>
                </label>
              </div>
            </div>
            <div class="cardRow w3-padding-8">
              <label class="w3-label">Leads</label>
              <div class="w3-right-align">
                <label class="switch">
                  <input type="checkbox" v-model="state.siteData.content.leads.enabled">
                  <span class="slider"></span>
                </label>
              </div>
            </div>
            <div class="cardRow w3-padding-8">
              <label class="w3-label">Sidebar</label>
              <div class="w3-right-align">
                <label class="switch">
                  <input type="checkbox" v-model="state.siteData.content.sidebar.enabled">
                  <span class="slider"></span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="inputCard">
          <header>Additional CSS</header>
          <div class="content">
            <div class="input-row w3-padding-8">
              <label>CSS Code</label>
              <textarea v-model="state.siteData.content.css" class="w3-input w3-border" rows="10"></textarea>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var dataStore = require('../../dataStore').default

export default {
  name: 'cmsSettingsContent',
  data() {
    return {
      state: dataStore.state
    }
  },
  methods: {
    uploadLogo(files) {
      dataStore.uploadImage(files).then((path) => {
        this.state.siteData.site_logo.url = path
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/cms/cmsSettingsContent.vue